import React, { useState, useEffect } from "react";
import AppBar from "@mui/material/AppBar";

import CssBaseline from "@mui/material/CssBaseline";
import SearchBox from "../../common/components/SearchBox";
import {
  Typography,
  Box,
  Button,
  Menu,
  MenuItem,
  IconButton,
  Badge,
  Divider,
  TextField,
  Tooltip,
} from "@mui/material";
import { connect } from "react-redux";
import { CardContent, Toolbar } from "@mui/material";
import { useHistory } from "react-router-dom";
import {
  getDDEPostDistributions,
  getDDEPostLimits,
  saveSchoolPostLimits,
  confirmDDEPostDistributions,
} from "../../../../store/posts/actions";
import ReactPaginate from "react-paginate";
import PostRequestDetailsDialog from "./PostRequestDetailsDialog";
import DragIndicatorIcon from "@mui/icons-material/DragIndicator";
import PostLimitDialog from "./PostLimitDialog";
import ConfirmationDialog from "../../common/components/ConfirmationDialog";
import { showError } from "../../../toastify";

const PostsDistributionREB = (props) => {
  const { user, ddePostLimits, getDDEPostLimits } = props;

  useEffect(() => {
    getDDEPostLimits();
  }, [user?.selectedEntity, user?.selectedAcademicYear]);

  return (
    <div className="px-4 pt-2">
      <div className="border rounded">
        <AppBar position="static" elevation={0} className="app-bar w-100">
          <Toolbar
            style={{
              minHeight: "0px",
              borderBottom: "3px solid #e9ecef",
            }}
            className=" my-0 py-2"
          >
            <Typography
              variant="p"
              noWrap
              component="div"
              className="d-flex  align-items-center text-uppercase text-primary font-weight-bold"
            >
              <span className="mr-2 text-dark">Post Distributions</span>
              <span className="material-icons" style={{ color: "#cecece" }}>
                chevron_right
              </span>
              <span
                className="d-block text-truncate"
                style={{ maxWidth: "70%" }}
              >
                <span>{user.selectedEntity?.name} </span>
              </span>
            </Typography>
            <Box sx={{ flexGrow: 1 }} />
          </Toolbar>
        </AppBar>

        <div
          style={{
            backgroundColor: "#f3f4f6",
            borderRadius: "0.5rem",
            boxShadow: "0 5px 5px 0 rgb(42 119 144 / 5%)",
            MozBoxShadow: "0 5px 5px 0 rgba(42,119,144,.05)",
            height: "67vh",
            overflowY: "auto",
          }}
          className="px-3 pt-3"
        >
          <div className="jumbotron jumbotron-fluid text-center">
            <div className="container py-5 ">
              <div className="">
                <Typography
                  variant="p"
                  noWrap
                  component="div"
                  className="d-flex mb-4  align-items-center justify-content-center text-uppercase text-primary font-weight-bold"
                >
                  <span className="mr-2">Limit</span>

                  <span className="d-flex">
                    <span className="text-dark mr-1">A0:</span>
                    <span className="badge badge-secondary d-flex align-items-center">
                      {ddePostLimits.a0Limit}
                    </span>
                  </span>

                  <DragIndicatorIcon style={{ color: "#cecece" }} />

                  <span className="d-flex">
                    <span className="text-dark mr-1">A1:</span>
                    <span className="badge badge-secondary d-flex align-items-center">
                      {ddePostLimits.a1Limit}
                    </span>
                  </span>

                  <DragIndicatorIcon style={{ color: "#cecece" }} />
                  <span className="d-flex">
                    <span className="text-dark mr-1">A2:</span>
                    <span className="badge badge-secondary d-flex align-items-center">
                      {ddePostLimits.a2Limit}
                    </span>
                  </span>
                </Typography>
                {/* <p className="text-primary text-uppercase mr-2"></p> */}
                <p className="mt-3 text-primary text-uppercase mr-2">
                  Distributed
                  <span className="badge d-inline-flex align-items-center">
                    A0:{" "}
                    <span
                      className={`badge p-2 badge-${
                        +ddePostLimits.a0Remaining === +ddePostLimits.a0Limit &&
                        +ddePostLimits.a0Remaining > 0
                          ? "success"
                          : +ddePostLimits.a0Remaining < +ddePostLimits.a0Limit
                          ? "primary"
                          : "danger"
                      } mx-1`}
                    >
                      {ddePostLimits.a0Remaining || 0}
                    </span>
                    {" - "} A1:{" "}
                    <span
                      className={`badge p-2 badge-${
                        +ddePostLimits.a1Remaining === +ddePostLimits.a1Limit &&
                        +ddePostLimits.a1Remaining > 0
                          ? "success"
                          : +ddePostLimits.a1Remaining < +ddePostLimits.a1Limit
                          ? "primary"
                          : "danger"
                      } mx-1`}
                    >
                      {ddePostLimits.a1Remaining || 0}
                    </span>
                    {" - "} A2:{" "}
                    <span
                      className={`badge p-2 badge-${
                        +ddePostLimits.a2Remaining === +ddePostLimits.a2Limit &&
                        +ddePostLimits.a2Remaining > 0
                          ? "success"
                          : +ddePostLimits.a2Remaining < +ddePostLimits.a2Limit
                          ? "primary"
                          : "danger"
                      } mx-1`}
                    >
                      {ddePostLimits.a2Remaining || 0}
                    </span>
                  </span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = ({
  user,
  loading,
  ddePostDistributions,
  ddePostLimits,
  selectedUnit,
}) => {
  return { user, loading, ddePostDistributions, ddePostLimits, selectedUnit };
};

export default connect(mapStateToProps, {
  getDDEPostDistributions,
  getDDEPostLimits,
  saveSchoolPostLimits,
  confirmDDEPostDistributions,
})(PostsDistributionREB);
